import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { Toggle, SubTitle, Spacer, Button, TagInput, Text, Theme } from "@dspworkplace/ui";
import SettingsContext from "../context";
import { getCompanyId, showToast } from "../../../Utilities";
import { toast } from "../../../components/Toasts";
import { useAuth } from "../../../Auth";
import { AccessCheck, IsGranted } from "../../../security";
import { LoadingView } from "../../../components/Loading";

const TagInputContainer = styled.div`
    width: 500px;
    label {
        width: 500px;
    }
    div {
        width: 500px;
    }
`;

const EnforceCompletionInspection = () => {
    // @ts-ignore
    const { api } = useAuth();
    // @ts-ignore
    const [state, dispatch] = useContext(SettingsContext);
    const { register, handleSubmit } = useForm();
    const [loadingSave, setLoadingSave] = useState(false);
    const [loadingRoles, setLoadingRoles] = useState(true);
    const [enforceCompletionOfLoadoutInspectionBeforePunchIn, setEnforceCompletionOfLoadoutInspectionBeforePunchIn] = useState(false);
    const [enforceCompletionOfRTSInspectionBeforePunchOut, setEnforceCompletionOfRTSInspectionBeforePunchOut] = useState(false);
    const [permissionLevel, setPermissionLevel] = useState([]);
    const [roleOptions, setRoleOptions] = useState([]);
    //Show announcement at showOnCorporateDevice is ON by default
    const [showOnPersonalDevice, setShowOnPersonalDevice] = useState(false);
    const [showOnCorporateDevice, setShowOnCorporateDevice] = useState(true);
    
    const fetchRoles = async () => {
        try {
            setLoadingRoles(true);
            const response = await api.post("/api/lazy/manage/data", {
                actions: {
                    response: {
                        Role: {
                            findBy: {
                                get: "roles",
                                criteria: {
                                    company: getCompanyId(),
                                    isArchive: false
                                },
                                includes: ["id", "roleName", "name"]
                            }
                        }
                    }
                }
            });

            const roles = response.data.data.roles || [];
            const bypassRoles = state.companySetting?.inspectionBypassRoles || [];

            const formattedRoles = roles.map(role => ({
                name: role.roleName,
                value: role.name,
                selected: bypassRoles.includes(role.name)
            }));

            setRoleOptions(formattedRoles);
            setLoadingRoles(false);
        } catch (e) {
            console.error("Error fetching roles:", e);
            setLoadingRoles(false);
        }
    };

    const onSubmit = async (data, evt) => {
        let form = evt.target;
        try {
            setLoadingSave(true);
            form.querySelector("button").disabled = true;
            
            const showAnnouncementAt = showOnPersonalDevice ? 1 : 2;
            
            let updateRecord = {
                enforceCompletionOfLoadoutInspectionBeforePunchIn: data.enforceCompletionOfLoadoutInspectionBeforePunchIn,
                enforceCompletionOfRTSInspectionBeforePunchOut: data.enforceCompletionOfRTSInspectionBeforePunchOut,
                inspectionBypassRoles: data.inspectionBypassRoles,
                company: getCompanyId(),
                showAnnouncementAt: showAnnouncementAt
            };
            setEnforceCompletionOfLoadoutInspectionBeforePunchIn(data.enforceCompletionOfLoadoutInspectionBeforePunchIn);
            setEnforceCompletionOfRTSInspectionBeforePunchOut(data.enforceCompletionOfRTSInspectionBeforePunchOut);
            setPermissionLevel(data.inspectionBypassRoles);
            api.post("/api/lazy/manage/data", {
                actions: {
                    response: {
                        CompanySetting: {
                            custom: {
                                functionName: "updateEnforceCompletionOfInspectionSettings",
                                get: "updateSetting",
                                criteria: updateRecord,
                            },
                        },
                    },
                },
            }).then((response) => {
                setLoadingSave(false);
                toast({
                    type: "success",
                    title: "Enforce Completion of Inspection Settings",
                    content: "Updates completed",
                });
                localStorage.setItem("enforceCompletionOfLoadoutInspectionBeforePunchIn", data.enforceCompletionOfLoadoutInspectionBeforePunchIn);
                localStorage.setItem("enforceCompletionOfRTSInspectionBeforePunchOut", data.enforceCompletionOfRTSInspectionBeforePunchOut);
                let companySetting = state.companySetting;
                state.companySetting.enforceCompletionOfLoadoutInspectionBeforePunchIn = data.enforceCompletionOfLoadoutInspectionBeforePunchIn;
                state.companySetting.enforceCompletionOfRTSInspectionBeforePunchOut = data.enforceCompletionOfRTSInspectionBeforePunchOut;
                state.companySetting.inspectionBypassRoles = data.inspectionBypassRoles;
                state.companySetting.showAnnouncementAt = showAnnouncementAt;
                dispatch({
                    type: "UPDATE_COMPNY_SETTING",
                    payload: companySetting,
                });
            })
            .then(() => (form.querySelector("button").disabled = false));
        } catch (e) {
            await showToast({ type: "error", title: "Error", content: JSON.stringify(e) });
            form.querySelector("button").disabled = false;
            setLoadingSave(false);
        }
    };

    useEffect(() => {
        setEnforceCompletionOfLoadoutInspectionBeforePunchIn(state.companySetting?.enforceCompletionOfLoadoutInspectionBeforePunchIn);
        setEnforceCompletionOfRTSInspectionBeforePunchOut(state.companySetting?.enforceCompletionOfRTSInspectionBeforePunchOut);
        setPermissionLevel(state.companySetting?.inspectionBypassRoles);
        fetchRoles();
        if (state.companySetting?.showAnnouncementAt === 1) {
            setShowOnPersonalDevice(true);
            setShowOnCorporateDevice(false);
        } else if (state.companySetting?.showAnnouncementAt === 2) {
            setShowOnCorporateDevice(true);
            setShowOnPersonalDevice(false);
        }
    }, [state]);

    const showBypassSection = enforceCompletionOfLoadoutInspectionBeforePunchIn || enforceCompletionOfRTSInspectionBeforePunchOut;

    const handlePersonalDevice = () => {
        if (!showOnPersonalDevice) {
            setShowOnPersonalDevice(true);
            setShowOnCorporateDevice(false);
        } else {
            setShowOnPersonalDevice(false);
            setShowOnCorporateDevice(true);
        }
    };

    const handleCorporateDevice = () => {
        if (!showOnCorporateDevice) {
            setShowOnCorporateDevice(true);
            setShowOnPersonalDevice(false);
        } else {
            setShowOnCorporateDevice(false);
            setShowOnPersonalDevice(true);
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <SubTitle>Enforce Completion of Inspection Settings</SubTitle>
            <Spacer bottom={3} />
            <Toggle
                ref={register}
                name="enforceCompletionOfLoadoutInspectionBeforePunchIn"
                singleText="Enforce completion of Load out Inspection before punch in."
                on={enforceCompletionOfLoadoutInspectionBeforePunchIn}
                onChange={(e) => {
                    setEnforceCompletionOfLoadoutInspectionBeforePunchIn(e.target.checked);
                }}
            />
            <Spacer bottom={5} />
            <div>
                <Spacer bottom={2} />
                <Toggle
                    ref={register}
                    name="enforceCompletionOfRTSInspectionBeforePunchOut"
                    singleText="Enforce completion of RTS Inspection before punch out."
                    on={enforceCompletionOfRTSInspectionBeforePunchOut}
                    onChange={(e) => {
                        setEnforceCompletionOfRTSInspectionBeforePunchOut(e.target.checked);
                    }}
                />
                <Spacer bottom={5} />
            </div>
            {showBypassSection && (
                <>
                    <Text color={Theme.colors.error.text} style={{ fontWeight: 500 }}>
                        The following permission levels can bypass the forced inspection before Punch In/Out
                    </Text>
                    <Spacer bottom={3} />
                    {loadingRoles ? (
                        <LoadingView containerWidth={'400px'} imgWidth={'40px'}/>
                    ) : (
                        <TagInputContainer>
                            <TagInput
                                label={"Permission Level"}
                                options={roleOptions}
                                size="big"
                                name={'inspectionBypassRoles'}
                                ref={register}
                                placeholder={"Select permission level(s)"}
                                defaultValues={permissionLevel}
                            />
                        </TagInputContainer>
                    )}
                    <Spacer bottom={5} />
                </>
            )}
            
            <SubTitle>Show Announcement At</SubTitle>
            <div>
                <Spacer bottom={2} />
                <Toggle
                    ref={register}
                    name="punchInOnAnyDevice"
                    singleText="Punch-in on any device."
                    on={showOnPersonalDevice ? true : false}
                    onChange={(e) => {
                        handlePersonalDevice();
                    }}
                />
                <Spacer bottom={5} />
            </div>
            <div>
                <Spacer bottom={2} />
                <Toggle
                    ref={register}
                    name="loginOnCorporateDevice"
                    singleText="Login on a corporate device."
                    on={showOnCorporateDevice ? true : false}
                    onChange={(e) => {
                        handleCorporateDevice();
                    }}
                />
                <Spacer bottom={5} />
            </div>
            <IsGranted feature={AccessCheck.features.SETTINGS} ops={[AccessCheck.OPS.U]}>
                <Spacer bottom={5} />
                <Button type="primary">{loadingSave ? "Saving ..." : "Save"}</Button>
            </IsGranted>
        </form>
    );
};

export default EnforceCompletionInspection;
